<template>
  <div id="video-show">
    <disabled-overlay />
    <profile-module />
    <b-col>
      <h1 class="title">{{ $t('pages.video.title') }}</h1>
    </b-col>
    <e-index
      :uri="$helper.getUri('video')"
      :modal-uri-create="`api/public/memorial/${id}/video`"
      :modal-uri="`api/memorial/${id}/video`"
      :order-call-back="orderCallBack"
      :can-manage="$root.canManage()"
      :can-create="!$root.isDemo() || $root.canManage()"
      name="video"
      mode="mosaic"
    >
      <div slot="mosaic-content" slot-scope="ctx">
        <span class="red-text step-title">{{ $helper.demoFallbackTranslation(ctx.item, 'title') }}</span>
        <div class="clearfix" />
        <img
          :src="videoThumbnail(ctx.item.url)"
          :alt="ctx.item.title"
          class="img-fluid"
          @click="openModal(modalName('video'), ctx.item)"
        >
        <contact-entity :contact="ctx.item.contact" />
      </div>
    </e-index>
    <e-modal :event-id="modalName('video')" :title="$helper.demoFallbackTranslation(video, 'title')">
      <b-embed
        :src="videoUrl"
        type="iframe"
        aspect="16by9"
        allowfullscreen
      />
      <p>{{ $helper.demoFallbackTranslation(video, 'description') }}</p>
    </e-modal>
  </div>
</template>

<script>
  import EIndex from '@/components/EIndex';
  import EModal from '@/components/EModal';
  import ProfileModule from '@/components/ProfileModule';
  import DisabledOverlay from '@/components/DisabledOverlay';
  import ContactEntity from '@/components/ContactEntity';
  import MemorialGuard from '@/mixins/MemorialGuard';

  export default {
    name: 'VideoIndex',
    components: {
      EIndex,
      EModal,
      ProfileModule,
      DisabledOverlay,
      ContactEntity,
    },
    mixins: [
      MemorialGuard,
    ],
    props: {
      id: {
        type: [Number, String],
        default: null,
      },
    },
    data() {
      return {
        // eslint-disable-next-line no-underscore-dangle
        uid: this._uid,
        video: {},
        videoUrl: '',
        videoIdRegex: /(v=|be\/)((\w|-)+)$/,
        orderCallBack(collection) {
          return _.orderBy(collection, ['created_at'], ['desc']);
        },
      };
    },
    mounted() {
      this.$bus.$on(`t-event.t-modal.video-${this.uid}.closed`, () => {
        this.videoUrl = '';
      });
    },
    methods: {
      videoId(url) {
        return url.match(this.videoIdRegex)[2];
      },
      videoThumbnail(url) {
        const id = this.videoId(url);
        return `https://img.youtube.com/vi/${id}/0.jpg`;
      },
      modalName(action) {
        return `${action}-${this.uid}`;
      },
      openModal(id, data = null) {
        const videoId = this.videoId(data.url);
        this.videoUrl = `https://www.youtube.com/embed/${videoId}`;
        this.video = data;
        this.$bus.$emit(`t-event.t-modal.${id}.open`, data);
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '~@/scss/vars';

  img {
    cursor: pointer;
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/views/Video/index.vue